import { render, staticRenderFns } from "./link-to.vue?vue&type=template&id=f251019c&scoped=true&"
import script from "./link-to.vue?vue&type=script&lang=js&"
export * from "./link-to.vue?vue&type=script&lang=js&"
import style0 from "./link-to.vue?vue&type=style&index=0&id=f251019c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f251019c",
  null
  
)

export default component.exports